import axios from "axios";
import GLOBAL from "../GLOBAL";
import { token } from "../config/access-token";
class MainModel {
  directEndpointFetch = (endpoint, data) => {
    let company_table_uuid = localStorage.getItem("company_table_uuid") || "";
    let token_line = localStorage.getItem("token_line") || "";
    const isFormData = data.body instanceof FormData;

    return axios({
      url: endpoint,
      method: data.method,
      headers: {
        Accept: "application/json",
        ...(isFormData ? {} : { "Content-Type": "application/json" }),
        company_table_uuid,
        token_line,
      },
      data: data.body,
    })
      .then((response) => response.data)
      .catch((error) => ({ require: false, data: [], error }));
  };

  authEndpointFetch = async (endpoint, data) => {
    const access_token = token.get(); // ✅ ดึง token สดจาก localStorage
    const company_table_uuid = localStorage.getItem("company_table_uuid") || "";
    const token_line = localStorage.getItem("token_line") || "";
    const isFormData = data.body instanceof FormData;
    try {
      const response = await axios({
        url: endpoint,
        method: data.method,
        headers: {
          Accept: "application/json",
          "x-access-token": access_token,
          ...(isFormData ? {} : { "Content-Type": "application/json" }),
          company_table_uuid,
          token_line,
        },
        data: data.body,
      });

      if (response.data.unauthorized) {
        localStorage.clear();
        window.location.reload();
      }

      return response.data;
    } catch (error) {
      console.error("API Error:", error);
      return { require: false, data: [], error };
    }
  };

  async authUploadFile(endpoint, data) {
    const access_token = token.get(); // ✅ ใช้ getter
    // Debug: log upload endpoint / method / body type for troubleshooting
    try {
      console.debug("authUploadFile -> endpoint:", endpoint);
      console.debug("authUploadFile -> method:", data.method);
      console.debug(
        "authUploadFile -> body is FormData:",
        data.body instanceof FormData
      );
    } catch (err) {
      /* ignore debug errors */
    }

    const response = await fetch(endpoint, {
      method: data.method,
      headers: {
        "x-access-token": access_token,
      },
      body: data.body,
    }).catch((error) => console.log("error", error));

    if (!response) return { require: false, data: [], error: "No response" };
    if (response.unauthorized) {
      console.log("unauthorized", response.error);
      localStorage.clear();
      window.location.reload();
    }

    return response;
  }

  async authParamsUploadFile(endpoint, data) {
    const access_token = token.get();
    const response = await fetch(endpoint, {
      method: data.method,
      headers: {
        "x-access-token": access_token,
      },
      body: data.body,
    }).catch((error) => console.log("error", error));

    if (!response) return { require: false, data: [], error: "No response" };
    if (response.unauthorized) {
      console.log("unauthorized", response.error);
      localStorage.clear();
      window.location.reload();
    }

    return response;
  }

  async authDeleteUploadFile(endpoint, data) {
    const access_token = token.get();
    // Debug: log what we are about to send to the server
    try {
      console.debug("authDeleteUploadFile -> endpoint:", endpoint);
      console.debug("authDeleteUploadFile -> method:", data.method);
      // attempt to show body safely
      try {
        console.debug("authDeleteUploadFile -> body:",
          data.body instanceof FormData ? "[FormData]" : data.body);
      } catch (err) {
        console.debug("authDeleteUploadFile -> body (unserializable)");
      }
    } catch (err) {
      /* ignore debug errors */
    }

    const response = await fetch(endpoint, {
      method: data.method,
      headers: {
        "x-access-token": access_token,
      },
      body: data.body,
    }).catch((error) => console.log("error", error));

    if (!response) return { require: false, data: [], error: "No response" };
    if (response.unauthorized) {
      console.log("unauthorized", response.error);
      localStorage.clear();
      window.location.reload();
    }

    return response;
  }

  async authUploadImageFile({ url, method, body }) {
    const access_token = token.get();
    const isFormData = body instanceof FormData;

    try {
      const response = await fetch(url, {
        method,
        headers: {
          ...(isFormData ? {} : { "Content-Type": "application/json" }),
          "x-access-token": access_token,
        },
        body,
      });

      return await response.json();
    } catch (error) {
      console.error("API Error:", error);
      return { require: false, data: [], error };
    }
  }

  async authParamsUploadFileImage({ url, method, body }) {
    const access_token = token.get();
    try {
      const isFormData = body instanceof FormData;
      const fetchBody = isFormData ? body : JSON.stringify(body);
      const response = await fetch(url, {
        method,
        headers: {
          ...(isFormData ? {} : { "Content-Type": "application/json" }),
          "x-access-token": access_token,
        },
        body: fetchBody,
      });
      const result = await response.json();
      if (!result.require || !result.files) return [];
      return result.files.map((f) => {
        const byteCharacters = atob(f.buffer);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new File([byteArray], f.file_name, { type: f.mime_type });
      });
    } catch (error) {
      console.error("authParamsUploadFileImage API Error:", error);
      return [];
    }
  }
}

export class BaseFetch extends MainModel {
  directFetch = (data) =>
    this.directEndpointFetch(`${GLOBAL.BASE_SERVER.URL}${data.url}`, data);
  authFetch = (data) =>
    this.authEndpointFetch(`${GLOBAL.BASE_SERVER.URL}${data.url}`, data);
  authUpload = (data) =>
    this.authUploadFile(`${GLOBAL.BASE_SERVER.URL}${data.url}`, data);
  authParamsUpload = (data) =>
    this.authParamsUploadFile(`${GLOBAL.BASE_SERVER.URL}${data.url}`, {
      method: data.method,
      body: data.body,
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => response.json()) // ได้ JSON ที่มี array
      .then((result) => {
        if (!result.require) return [];

        return result.files.map((f) => {
          // แปลง base64 -> Uint8Array -> File
          const byteCharacters = atob(f.buffer);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);

          return new File([byteArray], f.file_name, { type: f.mime_type });
        });
      })
      .catch((error) => console.log("error", error));
  authDeleteUpload = (data) =>
    this.authDeleteUploadFile(`${GLOBAL.BASE_SERVER.URL}${data.url}`, {
      method: data.method,
      body: data.body,
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => response)
      .then((e) => e)
      .catch((error) => console.log("error", error));
  

  authParamsUploadFileImageFetch = (data) =>
    this.authParamsUploadFileImage({
      url: `${GLOBAL.BASE_SERVER.URL}${data.url}`,
      method: data.method,
      body: data.body,
    });
}
